import { shellStringResources } from '../../Resources/ShellStringResources';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';

@Metamodel.model({
    name: 'Retry Policy',
    display: [shellStringResources.ModelName_RetryPolicy]
})
export class RetryPolicy {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_RetryCount,
        constraint: {
            required: false,
            minimum: 0
        }
    })
    public count?: number;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_RetryInterval,
        constraint: {
            required: false,
            minimum: 1
        }
    })
    public interval?: number;
}
